export interface DelayDialogInterface {
  delayTime: number;
  title: string;
  text: string;
}
